import { createRoute, Link } from "@tanstack/solid-router";
import { ArrowLeft } from "@fleet/icons";
import { msg } from "@lingui/core/macro";
import { rootRoute } from "@/routes/__root";
import { useI18n } from "@/providers/i18n-provider";
import { CountAndPlayGame } from "@/features/games/count-and-play-game";
import { PlayErrorBoundary } from "@/components/play-error-boundary";

function CountAndPlayPage() {
  const { t } = useI18n();
  return (
    <main class="kid-stage-screen screen-enter bg-gradient-to-b from-amber-100 to-orange-300 p-3">
      <header class="flex items-center pb-2">
        <Link
          to="/"
          class="press flex h-12 w-12 items-center justify-center rounded-full bg-white/80 shadow"
          aria-label={t(msg`Back`)}
        >
          <ArrowLeft class="h-6 w-6 text-orange-900" />
        </Link>
      </header>
      <div class="min-h-0 flex-1">
        <PlayErrorBoundary scope="count-and-play">
          <CountAndPlayGame />
        </PlayErrorBoundary>
      </div>
    </main>
  );
}

export const countAndPlayRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/games/count-and-play",
  component: CountAndPlayPage,
});
